(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ct-reveal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-reveal')) {
    customElements.define(
      'ct-reveal',
      class CtReveal extends HTMLElement {
        connectedCallback() {
          this.inner = this.querySelector('.ct-reveal__inner');
          this.nodes = Array.from(this.querySelectorAll('[data-reveal-node]'));
          this.progress = 0;
          if (!this.inner || !this.nodes.length) return;

          this.revealPoint = parseFloat(this.dataset.revealPoint) || 0.65;
          this.ticking = false;
          this.onScroll = this.onScroll.bind(this);
          this.measure = this.measure.bind(this);

          const editor = window.Shopify && Shopify.designMode;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Editor + reduced motion: show everything, skip scroll tracking so
          // merchants can edit every node and motion-sensitive users see it all.
          if (editor || reduced) {
            this.revealAll();
            if (editor) {
              window.addEventListener('resize', this.measure, { passive: true });
            }
            return;
          }

          // Switch on the hidden starting state only now that JS is driving it.
          this.classList.add('is-ready');
          this.measure();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.measure, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.measure);
        }

        measure() {
          const innerRect = this.inner.getBoundingClientRect();
          const h = innerRect.height || 1;
          // Each node's threshold = its dot centre as a 0–1 ratio down the rail.
          this.thresholds = this.nodes.map((node) => {
            const dot = node.querySelector('.ct-reveal__dot') || node;
            const r = dot.getBoundingClientRect();
            return Math.max(0, Math.min(1, (r.top - innerRect.top + r.height / 2) / h));
          });
          this.onScroll();
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const rect = this.inner.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const ref = vh * this.revealPoint;
            let p = (ref - rect.top) / (rect.height || 1);
            p = Math.max(0, Math.min(1, p));
            // Monotonic: the reveal only ever moves forward.
            if (p > this.progress) this.progress = p;
            this.apply(this.progress);
            this.ticking = false;
          });
        }

        apply(p) {
          this.style.setProperty('--ct-reveal-progress', p);
          if (!this.thresholds) return;
          this.nodes.forEach((node, i) => {
            if (p >= this.thresholds[i] - 0.001) {
              node.classList.add('is-revealed', 'is-reached');
            }
          });
        }

        revealAll() {
          this.style.setProperty('--ct-reveal-progress', 1);
          this.nodes.forEach((node) => node.classList.add('is-revealed', 'is-reached'));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ct-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-subscription')) {
    customElements.define(
      'ct-subscription',
      class CtSubscription extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');

          // Every `selling_plan` input, including the hidden one used in
          // single-option mode — these are what get suppressed for a one-time
          // purchase. The radios are a subset, and drive the selected mode.
          this.planInputs = Array.from(this.querySelectorAll('input[name="selling_plan"]'));
          this.planRadios = this.planInputs.filter((i) => i.type === 'radio');
          this.hasHiddenPlan = this.planInputs.some((i) => i.type === 'hidden');

          // Classic layout: a separate text button that buys once. It must post
          // the jar itself at quantity 1 with no plan, whatever card is
          // selected: a supply card has already swapped the id input to its
          // N-day kit (QC 2026-10-14: "Buy once for $89" added the $267 kit, and
          // on Matcha the 90-day subscription). Apply the one-time state on
          // pointerdown / keydown, before any click or submit handler (theme or
          // Rebuy) serialises the form, and again on click and submit.
          const oneTime = this.querySelector('[data-ct-onetime]');
          if (oneTime) {
            const arm = () => this.applyOnetime();
            oneTime.addEventListener('pointerdown', arm);
            oneTime.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') arm();
            });
            oneTime.addEventListener('click', arm, true);
          }

          // Stacked layout: the one-time card is a blank-valued radio in the
          // same group. Capture phase so the inputs are already disabled by the
          // time product-form-component's own submit handler reads the form.
          if (this.form) {
            this.form.addEventListener(
              'submit',
              (e) => {
                if (oneTime && e.submitter === oneTime) this.applyOnetime();
                else if (this.dataset.mode === 'onetime') this.suppressPlans();
              },
              true
            );
          }

          // "How does my subscription work?" modal.
          const how = this.querySelector('[data-ct-how-dialog]');
          if (how) {
            this.querySelectorAll('[data-ct-how-open]').forEach((b) => b.addEventListener('click', () => how.showModal()));
            how.querySelectorAll('[data-ct-how-close]').forEach((b) => b.addEventListener('click', () => how.close()));
            how.addEventListener('click', (e) => {
              if (e.target === how) how.close();
            });
          }

          this.addEventListener('change', (event) => {
            if (event.target && event.target.name === 'selling_plan') this.sync();
          });

          // Products with real variants (the System's flavours): Horizon's
          // variant picker re-renders other blocks but not this one, so the
          // 90-day card would keep the first flavour's kit while the id input
          // moved to the new flavour. Swap in this block from the section HTML
          // the picker already fetched, keeping the plan the shopper chose.
          if (this.hasAttribute('data-ct-variants')) {
            this.onVariantUpdate = (event) => {
              const data = event.detail && event.detail.data;
              if (!data || !data.html || String(data.productId) !== this.dataset.productId) return;
              const fresh = data.html.querySelector(`ct-subscription[data-ct-key="${this.dataset.ctKey}"]`);
              if (!fresh) return;
              const chosen = this.planRadios.find((r) => r.checked);
              const next = document.importNode(fresh, true);
              if (chosen) {
                const match = Array.from(next.querySelectorAll('input[name="selling_plan"]')).find((r) => r.value === chosen.value);
                if (match) {
                  next.querySelectorAll('input[name="selling_plan"]').forEach((r) => r.removeAttribute('checked'));
                  match.setAttribute('checked', '');
                }
              }
              next.dataset.ctKeep = '';
              this.replaceWith(next);
            };
            document.addEventListener('variant:update', this.onVariantUpdate);
          }

          // `?plan=30-day` (any plan token, or `onetime`) preselects that card, so a
          // link can land on the monthly option where the template's default is
          // 90-day. First render only: a block swapped in after a flavour change
          // (data-ct-keep) keeps the shopper's own choice.
          const wanted = (new URLSearchParams(window.location.search).get('plan') || '').toLowerCase();
          if (wanted && !this.hasAttribute('data-ct-keep')) {
            const pick = this.planRadios.find((r) =>
              wanted === 'onetime' ? r.value === '' : r.value === wanted || (r.dataset.hay || '').toLowerCase().includes(wanted)
            );
            if (pick) {
              this.planRadios.forEach((r) => (r.checked = false));
              pick.checked = true;
            }
          }

          this.sync();
        }

        disconnectedCallback() {
          if (this.onVariantUpdate) document.removeEventListener('variant:update', this.onVariantUpdate);
        }

        // Disable rather than remove, then restore on the next tick: the form
        // has already been serialised by then, and the radios stay clickable.
        suppressPlans() {
          this.planInputs.forEach((i) => (i.disabled = true));
          setTimeout(() => this.planInputs.forEach((i) => (i.disabled = false)), 0);
        }

        // "Buy once" button (classic layout): the jar's own variant, quantity
        // 1, no selling plan. Held for a moment so handlers that read the form
        // asynchronously still see it, then the selected card is restored.
        applyOnetime() {
          this.planInputs.forEach((i) => (i.disabled = true));
          const idInput = this.form && this.form.querySelector('input[name="id"]');
          if (idInput && idInput.dataset.ctBase) idInput.value = idInput.dataset.ctBase;
          const qty = this.form && this.form.querySelector('input[name="quantity"]');
          if (qty) qty.value = 1;
          clearTimeout(this.onetimeTimer);
          this.onetimeTimer = setTimeout(() => {
            this.planInputs.forEach((i) => (i.disabled = false));
            this.sync();
          }, 1500);
        }

        sync() {
          // Single-option mode has no radio to read, so fall back to the
          // hidden plan input, which carries the same data attributes.
          const active =
            this.planRadios.find((r) => r.checked) || this.planInputs.find((i) => i.type === 'hidden');
          const mode = active && active.value !== '' ? 'subscribe' : 'onetime';
          this.dataset.mode = mode;

          const label = this.querySelector('[data-ct-atc-label]');
          if (label) {
            const next = mode === 'onetime' ? this.dataset.labelOnetime : this.dataset.labelSubscribe;
            if (next) label.textContent = next;
          }

          const price = this.querySelector('[data-ct-atc-price]');
          if (price) {
            price.textContent = (mode === 'subscribe' && active && active.dataset.price) || '';
          }

          // November Event: "You save $X (Y%) today" for the selected card.
          const save = this.querySelector('[data-ct-save]');
          if (save) {
            const now = Number(active && active.dataset.ctNow);
            const was = Number(active && active.dataset.ctWas);
            if (now > 0 && was > now) {
              // The store's own money format (as the `money` filter prints the card prices), so the saving
              // reads "$74.09" next to "$186.90" whatever the visitor's browser locale (en-US showed "A$").
              let amount;
              const cents = was - now;
              const fmt = save.dataset.moneyFormat || '';
              const group = (n, dec, sep, point) => {
                const [i, f] = (n / 100).toFixed(dec).split('.');
                return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (f ? point + f : '');
              };
              if (/\{\{\s*amount/.test(fmt)) {
                amount = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => ({
                  amount: group(cents, 2, ',', '.'),
                  amount_no_decimals: group(cents, 0, ',', '.'),
                  amount_with_comma_separator: group(cents, 2, '.', ','),
                  amount_no_decimals_with_comma_separator: group(cents, 0, '.', ','),
                  amount_with_apostrophe_separator: group(cents, 2, "'", '.'),
                }[key] ?? group(cents, 2, ',', '.')));
              } else {
                try {
                  amount = new Intl.NumberFormat(undefined, { style: 'currency', currency: save.dataset.currency || 'USD' }).format(cents / 100);
                } catch (e) {
                  amount = '$' + (cents / 100).toFixed(2);
                }
              }
              const pct = Math.round(((was - now) * 100) / was);
              let text = (save.dataset.template || '').replace('[amount]', amount).replace('[pct]', pct);
              // Plans carry the gift unless marked false; the one-time card only when marked true.
              const gift = mode === 'subscribe' ? active.dataset.ctGift !== 'false' : !!active && active.dataset.ctGift === 'true';
              let extra = '';
              if (save.dataset.gift && gift) extra = save.dataset.gift.trim();
              else if (mode === 'subscribe' && active.dataset.ctGiftText) extra = active.dataset.ctGiftText;
              if (extra) text += ' ' + extra;
              // Cards whose benefits list free shipping say so here too (Max, 2 Nov).
              if (active && active.dataset.ctShip === 'true') text += ' + free shipping';
              save.textContent = text;
              save.hidden = false;
            } else {
              save.hidden = true;
            }
          }

          // Multi-month plans ship N units per delivery: keep the cart
          // quantity in step with the selection so the charge matches the
          // "$X × N = $total" the card promises. One-time always buys 1.
          // Supply plans post a different variant (the N-day supply kit) at
          // quantity 1 instead of N units of this product.
          const swap = (mode === 'subscribe' && active && active.dataset.variant) || '';
          const idInput = this.form && this.form.querySelector('input[name="id"]');
          if (idInput) {
            if (!idInput.dataset.ctBase) idInput.dataset.ctBase = idInput.value;
            idInput.value = swap || idInput.dataset.ctBase;
          }
          const qty = this.form && this.form.querySelector('input[name="quantity"]');
          if (qty) {
            const months = mode === 'subscribe' && active && parseInt(active.dataset.months || '1', 10);
            qty.value = !swap && months > 1 ? months : 1;
          }

          // Plan-scoped rows: `data-show-plan` holds a plan token, matched the
          // same way the Liquid side matches them — against the plan's id +
          // name + option values (`data-hay` on the plan input). No plan
          // selected (one-time) hides every plan-scoped row.
          const hay = (mode === 'subscribe' && active && active.dataset.hay) || '';
          this.querySelectorAll('[data-show-plan]').forEach((el) => {
            const tok = (el.dataset.showPlan || '').toLowerCase();
            const on = tok !== '' && hay.toLowerCase().includes(tok);
            el.toggleAttribute('data-plan-off', !on);
          });

          // Gallery follows the selection: each plan radio may carry
          // `data-media` (product media whose alt starts with the plan's
          // token); one-time goes back to the primary media. The first sync
          // only moves the gallery when the preselected plan has its own
          // image, and without animation, so the page opens on it.
          const mediaId =
            mode === 'subscribe' ? (active && active.dataset.media) || '' : this.dataset.onetimeMedia || '';
          const firstSync = !this.dataset.planReady;
          if (mediaId && mediaId !== this.shownMedia && !(firstSync && mode === 'onetime')) {
            this.shownMedia = mediaId;
            this.showMedia(mediaId, !firstSync);
          }
          this.dataset.planReady = '1';
        }

        async showMedia(mediaId, animate) {
          const scope = this.closest('.shopify-section') || document;
          const gallery = scope.querySelector('media-gallery slideshow-component');
          if (!gallery) return;
          await customElements.whenDefined('slideshow-component');
          // Slideshow sets its own initial position on the next frame; wait
          // past it so this selection isn't overwritten.
          if (!animate) await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
          // `select(n)` indexes the slideshow's visible slides, not the DOM.
          const slides = gallery.slides || Array.from(gallery.querySelectorAll('slideshow-slide'));
          const index = slides.findIndex((s) => s.querySelector(`[data-media-id="${mediaId}"]`));
          if (index < 0 || typeof gallery.select !== 'function') return;
          gallery.select(index, undefined, { animate });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ct-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-timeline')) {
    customElements.define(
      'ct-timeline',
      class CtTimeline extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.ct-timeline__bar');
          this.steps = Array.from(this.querySelectorAll('.ct-timeline__step'));
          if (!this.bar || !this.steps.length) return;

          this.startRatio = parseFloat(this.dataset.fillStart) || 0.85;
          this.endRatio = parseFloat(this.dataset.fillEnd) || 0.4;
          this.ticking = false;
          this.onScroll = this.onScroll.bind(this);
          this.measure = this.measure.bind(this);

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.reduced) {
            this.apply(1);
            return;
          }

          this.measure();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.measure, { passive: true });
          this.onScroll();

          // Theme editor: hold a step "reached" when the merchant selects it.
          if (window.Shopify && Shopify.designMode) {
            this.addEventListener('shopify:block:select', () => {
              this.measure();
              this.onScroll();
            });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.measure);
        }

        get vertical() {
          return window.matchMedia('(max-width: 749px)').matches;
        }

        measure() {
          const barRect = this.bar.getBoundingClientRect();

          // Position the line through the pill row's centre (desktop only;
          // mobile uses a full-height vertical line so no offset needed).
          const firstPill = this.steps[0] && this.steps[0].querySelector('.ct-timeline__pill');
          if (firstPill && !this.vertical) {
            const pr = firstPill.getBoundingClientRect();
            const center = pr.top - barRect.top + pr.height / 2 - 1;
            this.bar.style.setProperty('--ct-tl-line-top', center + 'px');
          }

          // Each step's "reached" threshold = its pill centre as a 0–1 ratio
          // along the fill axis.
          const span = this.vertical ? barRect.height : barRect.width || 1;
          this.thresholds = this.steps.map((step) => {
            const pill = step.querySelector('.ct-timeline__pill');
            const target = pill || step;
            const r = target.getBoundingClientRect();
            const offset = this.vertical
              ? r.top - barRect.top + r.height / 2
              : r.left - barRect.left + r.width / 2;
            return Math.max(0, Math.min(1, offset / span));
          });
          this.onScroll();
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const rect = this.bar.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const start = vh * this.startRatio;
            const end = vh * this.endRatio;
            const edge = this.vertical ? rect.top : rect.top;
            let p = (start - edge) / (start - end || 1);
            p = Math.max(0, Math.min(1, p));
            this.apply(p);
            this.ticking = false;
          });
        }

        apply(p) {
          this.style.setProperty('--ct-tl-progress', p);
          const thresholds = this.thresholds;
          this.steps.forEach((step, i) => {
            const reached = thresholds ? p >= thresholds[i] - 0.001 : true;
            step.classList.toggle('is-reached', reached);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
